import { Scale, Sparkles } from 'lucide-react';

const Logo = ({ variant = 'default', size = 'default' }) => {
  const sizes = {
    small: { 
      icon: 'w-10 h-10', 
      iconInner: 'w-5 h-5',
      star: 'w-3 h-3',
      textMain: 'text-base',
      textSub: 'text-[8px]',
      textTag: 'text-[6px]',
      gap: 'gap-2'
    },
    default: { 
      icon: 'w-12 h-12', 
      iconInner: 'w-6 h-6',
      star: 'w-4 h-4',
      textMain: 'text-lg',
      textSub: 'text-[10px]',
      textTag: 'text-[7px]',
      gap: 'gap-2'
    },
    large: { 
      icon: 'w-16 h-16', 
      iconInner: 'w-8 h-8',
      star: 'w-5 h-5',
      textMain: 'text-2xl',
      textSub: 'text-xs',
      textTag: 'text-[9px]',
      gap: 'gap-3'
    },
  };

  const s = sizes[size];
  const isLight = variant === 'light';

  return (
    <div className={`flex items-center ${s.gap}`} data-testid="logo">
      {/* Logo Icon - Burgundy square with golden scale */}
      <div className="relative">
        <div className={`${s.icon} rounded-lg bg-gradient-to-br from-[#722F37] to-[#5C252B] flex items-center justify-center shadow-lg border border-[#D4AF37]/30`}>
          <Scale className={`${s.iconInner} text-[#D4AF37]`} strokeWidth={1.5} />
        </div>
        {/* Golden star */}
        <div className="absolute -top-1 -right-1">
          <div className={`${s.star} bg-[#D4AF37] rounded-full flex items-center justify-center shadow-md`}>
            <Sparkles className={`${size === 'large' ? 'w-3 h-3' : 'w-2 h-2'} text-white`} />
          </div>
        </div>
      </div>
      
      {/* Logo Text */}
      <div className="flex flex-col leading-tight">
        <div className={`${s.textMain} font-bold tracking-tight`}>
          <span className={isLight ? 'text-white' : 'text-[#006F33]'}>Teranga</span>
          <span className="text-[#D4AF37]"> Global</span>
        </div>
        <div className={`${s.textSub} font-bold tracking-[0.2em] ${isLight ? 'text-[#D4AF37]' : 'text-[#D4AF37]'}`}>
          LEGAL
        </div>
        <div className={`${s.textTag} ${isLight ? 'text-slate-400' : 'text-slate-500'} tracking-wide mt-0.5 flex items-center gap-1`}>
          <span>Votre Conseil Juridique</span>
          <span className="inline-block">🇸🇳</span>
        </div>
      </div>
    </div>
  );
};

export default Logo;
